<template>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ $t('Создание') }}</h1>
      <div class="my-organization">
        <div class="bgw-pdg-20">
          <v-form
            ref="form"
            lazy-validation
            @submit.prevent="createUsageStandard"
            class="v-form"
          >
            <div class="form-group">
              <div class="quota-fields">
                <div class="quota-field field-xs" :class="{ invalid: $v.faunaLimit.year.$error }">
                  <div class="select-def">
                    <v-select
                      :items="refYears"
                      item-value="id"
                      item-text="transName"
                      v-model="faunaLimit.year"
                      outlined
                      dense
                      required
                      clearable
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <v-checkbox
                v-model="faunaLimit.copy"
                :label="$t('Копировать значение из предыдущего года')"
              ></v-checkbox>
            </div>
            <div class="form-bottom">
              <div class="form-action">
                <button
                  class="btn btn-default blue"
                  type="submit"
                >
                  {{ $t('Сохранить') }}
                </button>
                <button
                  class="btn btn-default gray"
                  type="button"
                  @click="onCancel"
                >
                  {{ $t('Отмена') }}
                </button>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import faunaLimit from '@/model/faunaLimit'
import { required } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    breadcrumbs: [],
    refYears: [],
    faunaLimit: {
      copy: true
    },
    rules: {
      faunaLimit: {
        year: { required }
      }
    }
  }),
  validations () {
    return this.rules
  },
  created () {
    this.getUsageStandardYears()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные для формы
    getUsageStandardYears () {
      this.setLoading(true)
      faunaLimit.getFaunaLimitFormData()
        .then((res) => {
          this.refYears = res.data.refYears
          this.generateBreadcrumbs()
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
    },
    // Создание
    createUsageStandard () {
      if (!this.validateForm()) {
        return
      }
      if (this.faunaLimit.copy) {
        this.faunaLimit.copy = 1
      } else {
        this.faunaLimit.copy = 0
      }
      this.setLoading(true)
      faunaLimit.createFaunaLimit(this.faunaLimit).then((response) => {
        this.$router.push({
          name: 'quota-usage-standard'
        })
        this.setLoading(false)
      }).catch((error) => {
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
        this.setLoading(false)
      })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Нормативы пользования'),
          disabled: false,
          href: '/quota-usage-standard'
        },
        {
          text: this.$i18n.t('Создание'),
          disabled: true
        }
      ]
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'quota-usage-standard'
      })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
